import { Icon } from "@/react/components/shared/Icon";

import { IconContainer } from "./IconContainer";

interface QuotationMarkProps {
  color: string;
}

export const QuotationMark = ({ color }: QuotationMarkProps) => (
  <IconContainer dataTestId="testimonial-quotation-mark">
    <Icon
      type="20-open-quote"
      useWithFillCurrentColor
      useWithStrokeCurrentColor
      style={{ color }}
      viewBox="0 0 20 20"
    />
  </IconContainer>
);
